import * as yup from 'yup';

import i18n from 'config/i18n';
import { getLocale } from 'utils/date';
import { toProtocolDate } from './ProtocolForm.utils';

import type { ProtocolDateValue } from './ProtocolForm.types';

const t = i18n.getFixedT(getLocale());

/** An empty valid until means valid indefinitely, so it can never lie before valid from */
const isNotBeforeValidFrom = (
  validUntil: ProtocolDateValue | undefined,
  validFrom: ProtocolDateValue
) => {
  const until = toProtocolDate(validUntil ?? null);
  const from = toProtocolDate(validFrom);
  return !until || !from || until >= from;
};

const schema = yup.object({
  name: yup
    .string()
    .trim()
    .required(t('adminPortal.protocols.form.nameRequired'))
    .max(255),
  validFrom: yup
    .mixed<ProtocolDateValue>()
    .nullable()
    .required(t('adminPortal.protocols.form.validFromRequired')),
  validUntil: yup
    .mixed<ProtocolDateValue>()
    .nullable()
    .test(
      'not-before-valid-from',
      t('adminPortal.protocols.form.validUntilBeforeValidFrom'),
      (validUntil, { parent }) =>
        isNotBeforeValidFrom(validUntil, parent.validFrom)
    )
});

export default schema;
